import React from "react";
import useFeatureToggles from "../../../../hooks/useFeatureToggles";
import { useInvoiceDispute } from "../../../../hooks/useInvoiceDispute";
import { Autocomplete, Chip, TextField } from "@mui/material";

type Props = {
  disputedReasonFilter: string[];
  onDisputedReasonFilterChange(disputedReasonFilter: string[]): void;
};

export function DisputedReasonFilter({ disputedReasonFilter, onDisputedReasonFilterChange }: Props) {
  const { isDisputedEnabled } = useFeatureToggles();
  const { disputeReasonCodes } = useInvoiceDispute(isDisputedEnabled);

  if (!isDisputedEnabled) return null;

  const selectedOptions = disputeReasonCodes.filter((code) => disputedReasonFilter.includes(code.id));

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      size="small"
      options={disputeReasonCodes}
      value={selectedOptions}
      getOptionLabel={(option) => option.description}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(_, value) => onDisputedReasonFilterChange(value.map((v) => v.id))}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={option.id}
            label={option.description}
            size="small"
            sx={{ textTransform: "capitalize", zIndex: 1000, fontSize: 12 }}
          />
        ))
      }
      renderInput={(params) => <TextField {...params} label="Disputed Reason" placeholder="Select reasons" />}
      sx={{ minWidth: 200 }}
    />
  );
}
